import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { borderRadii } from 'app/spacing';
import { isCellToday, isCellTomorrow, isTodaySaturday } from '../utils';

const Container = styled.div`
  border: 1px solid var(--color-border-medium);
  border-top-width: 0;
  border-right-width: 0;
  background-color: var(--color-background-white);
  height: ${({ cellHeight }) => (cellHeight ? `${cellHeight}px` : '42px')};
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ isToday, isLastDayOfWeek }) =>
    isToday &&
    isLastDayOfWeek &&
    css`
      border-right-width: 1px;
      border-right-color: var(--color-button-secondary-default);
    `}

  ${({ isTomorrow }) =>
    isTomorrow &&
    css`
      border-left-color: var(--color-button-secondary-default);
    `}
  ${({ isToday }) =>
    isToday &&
    css`
      border-left-color: var(--color-button-secondary-default);
      background-color: var(--color-background-hover);
    `}
  ${({ isLastRow }) =>
    isLastRow &&
    css`
      border-bottom-width: 0;
    `}
  ${({ isFirstRow, isLastColumn }) =>
    isFirstRow &&
    isLastColumn &&
    css`
      border-top-right-radius: ${borderRadii.small};
    `}
  ${({ isLastRow, isLastColumn }) =>
    isLastRow &&
    isLastColumn &&
    css`
      border-bottom-right-radius: ${borderRadii.small};
    `}
`;

const WeekCalendarCell = ({ date, children, ...rest }) => {
  return (
    <Container
      isToday={isCellToday(date)}
      isTomorrow={isCellTomorrow(date)}
      isLastDayOfWeek={isTodaySaturday()}
      {...rest}
    >
      {children}
    </Container>
  );
};

export default WeekCalendarCell;
